module.exports = __webpack_public_path__ + "img/21.31cffd78.jpg";